export { default as socialFacebook } from './social-facebook.svg'
export { default as socialInstagram } from './social-instagram.svg'
export { default as socialTwitter } from './social-twitter.svg'
export { default as socialYoutube } from './social-youtube.svg'
export { default as arrowUp } from './arrow-up.svg'
export { default as chevronDown } from './chevron-down.svg'
export { default as chevronLeft } from './chevron-left.svg'
